import { cookieManager } from "@/service/cookieManager";

const state = {
	button: {
		defaultBorder: "rounded",
	},

	commanderProducts: {
		listProducts: true,
	},

	showDelivery: false,
	showUberEats: false,
	showJustEat: false,
	showGlovo: false,
};

const getters = {
	buttonBorder: (state) => state.button.defaultBorder,
	listProducts: (state) => state.commanderProducts.listProducts,
	showDelivery: (state) => state.showDelivery,
	showUberEats: (state) => state.showUberEats,
	showJustEat: (state) => state.showJustEat,
	showGlovo: (state) => state.showGlovo,
};

const mutations = {
	setListProducts(state, value) {
		state.commanderProducts.listProducts = value;
	},
};

const actions = {
	initializeListProductsFromCookie({ commit }) {
		const cookieValue = cookieManager.getCookie("commanderStyle");
		if (cookieValue) {
			try {
				const parsed = JSON.parse(cookieValue);
				if (typeof parsed.listProducts === "boolean") {
					commit("setListProducts", parsed.listProducts);
				}
			} catch (e) {
				console.error("Error parsing commanderStyle cookie:", e);
			}
		}
	},

	updateListProducts({ commit, dispatch }, value) {
		commit("setListProducts", value);
		dispatch("saveViewOptionsToCookie");
	},

	saveViewOptionsToCookie({ state }) {
		cookieManager.setCookie("commanderStyle", JSON.stringify(state.commanderProducts));
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
